import { getIntervalForPeriod } from './getIntervalForPeriod';
import { PreDefinedPeriod } from '../types';

export const getDisplayRangeFromPreDefinedPeriod = (period: PreDefinedPeriod) => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const { start, end } = getIntervalForPeriod(period, timezone);
  const from = new Date(start.toISODate());
  const to = new Date(end.minus({ days: 1 }).toISODate());
  return { from, to };
};
